import { render, staticRenderFns } from "./CoozzyCaretUpIcon.vue?vue&type=template&id=2ab31408&scoped=true"
import script from "./CoozzyCaretUpIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCaretUpIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCaretUpIcon.vue?vue&type=style&index=0&id=2ab31408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab31408",
  null
  
)

export default component.exports